import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as ruleActions from '../store/actions';
import { ModuleListModel } from '../models/ModuleListModel';
import { RuleListModel } from '../models/RuleListModel';
import { ModuleConfiguration } from '../business-rule.module.config';
import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';
import { RuleService } from './RuleService';
import { QueryResponse } from '../../core/services/QueryResponse';
import { LoadPageByModulePayload } from '../store/actions/LoadPageByModulePayload';
import { ModelResponse } from '../../core/services/ModelResponse';
import { RuleCommonParameterModel } from '../models/RuleCommonParameterModel';


@Injectable()
export class RuleServiceEffects {
  constructor(
    private ruleService: RuleService,
    private actions$: Actions
  ) {
  }

  @Effect()
  getRuleList$: Observable<Action> = this.actions$.ofType(dashboardActions.getQueryListType<ModuleListModel>(ModuleConfiguration.moduleName, ModuleListModel))
      .map((a: dashboardActions.QueryListAction<ModuleListModel>) => a.payload)
    .switchMap((payload: LoadPagePayload) => this.ruleService.getRuleList(payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm)
      .map((response: QueryResponse<ModuleListModel>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, ModuleListModel, { errors: response.messages.map(m => m.value) });
        }
        return new dashboardActions.QuerySuccessAction(ModuleConfiguration.moduleName, ModuleListModel, { items: response.items, totalCount: response.totalCount });
      }));

  @Effect()
  getRuleListByModule$: Observable<Action> = this.actions$.ofType(ruleActions.getQueryListByModuleType<ModuleListModel>(ModuleConfiguration.moduleName, ModuleListModel))
    .map((a: ruleActions.QueryListByModuleAction<ModuleListModel>) => a.payload)
      .switchMap((payload: LoadPageByModulePayload) => this.ruleService.getRuleListByModule(payload.moduleName, payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm)
      .map((response: QueryResponse<ModuleListModel>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, ModuleListModel, { errors: response.messages.map(m => m.value) });
        }
        return new dashboardActions.QuerySuccessAction(ModuleConfiguration.moduleName, ModuleListModel, { items: response.items, totalCount: response.totalCount });
      }));

  @Effect()
  enableRule: Observable<Action> = this.actions$.ofType(ruleActions.ENABLE_RULE)
      .switchMap((a: ruleActions.EnableRuleAction) => this.ruleService.enableRule(a.payload.rule)
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, RuleListModel, { errors: response.messages.map(m => m.value) });
        }
        return new ruleActions.EnableRuleSuccessAction(a.payload);
      }));

  @Effect()
  disableRule: Observable<Action> = this.actions$.ofType(ruleActions.DISABLE_RULE)
    .switchMap((a: ruleActions.DisableRuleAction) => this.ruleService.disableRule(a.payload.rule)
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, RuleListModel, { errors: response.messages.map(m => m.value) });
        }
        return new ruleActions.DisableRuleSuccessAction(a.payload);
      }));

  @Effect()
  updateRuleStatus: Observable<Action> = this.actions$.ofType(ruleActions.UPDATE_RULE_STATUS)
    .switchMap((a: ruleActions.UpdateRuleStatusAction) => this.ruleService.updateRuleStatus(a.payload.rule)
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new dashboardActions.TileErrorsAction(ModuleConfiguration.moduleName, RuleListModel, { errors: response.messages.map(m => m.value) });
        }
        return new ruleActions.UpdateRuleStatusSuccessAction(a.payload);
      }));

  @Effect()
  updateRuleParameter: Observable<Action> = this.actions$.ofType(ruleActions.UPDATE_RULE_PARAMETER)
    .switchMap((a: ruleActions.UpdateRuleParameterAction) => this.ruleService.updateRuleParameter(a.payload.rule, a.payload.parameter)
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
        }
        return new ruleActions.UpdateRuleParameterSuccessAction(a.payload);
      }));

    
  @Effect()
  getRelatedDataSets: Observable<Action> = this.actions$.ofType(ruleActions.GET_RELATED_DATASETS)
    .switchMap((a: ruleActions.GetDataSetsAction) => this.ruleService.getRelatedDataSets(a.payload.model)
      .map((response: ModelResponse<string[]>) => {
        if (response.hasError) {
        }
        return new ruleActions.GetDataSetsSuccessAction({ model: response.model });
      }));

  @Effect()
  getComparisonDate: Observable<Action> = this.actions$.ofType(ruleActions.GET_COMPARISON_DATE)
    .switchMap((a: ruleActions.GetComparisonDateAction) => this.ruleService.getComparisonDate(a.payload.model)
      .map((response: ModelResponse<string[]>) => {
        if (response.hasError) {
        }
        return new ruleActions.GetComparisonDateSuccessAction({ model: response.model });
      }));

  @Effect()
  applyCommonParameters: Observable<Action> = this.actions$.ofType(ruleActions.APPLY_COMMON_PARAMETERS)
      .switchMap((a: ruleActions.ApplyCommonParametersAction) => this.ruleService.applyCommonParameters(a.payload.model)
        .map((response: ModelResponse<RuleCommonParameterModel>) => {
        if (response.hasError) {
        }
        return new ruleActions.ApplyCommonParametersSuccessAction({ model: response.model });
      }));
}



// WEBPACK FOOTER //
// ./src/app/businessRule/services/RuleService.effects.ts